<template>
  <section id="fotos">
    <div class="center-container">
      <div class="title">
        <h2>Fotos</h2>
        <h3>Imagens valem mais que mil palavras</h3>
        <div class="decoration">
          <div class="dotted-border"></div>
          <i class="fab fa-pagelines"></i>
          <div class="dotted-border"></div>
        </div>
      </div>

      <div class="gallery">
        <!-- lightbox containers hidden with CSS -->
        <div class="lightbox animate" id="img2">
          <LightboxClose />
          <LightboxPrev previous="#img24" />
          <LightboxNext next="#img4" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/2.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/2.jpg')} 500w, ${require('@/assets/img/photos/all/2.jpg')} 1000w`" />
        </div>

        <div class="lightbox animate" id="img4">
          <LightboxClose />
          <LightboxPrev previous="#img2" />
          <LightboxNext next="#img6" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/4.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/4.jpg')} 500w, ${require('@/assets/img/photos/all/4.jpg')} 1000w`" />
           />
        </div>

        <div class="lightbox animate" id="img6">
          <LightboxClose />
          <LightboxPrev previous="#img4" />
          <LightboxNext next="#img8" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/6.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/6.jpg')} 500w, ${require('@/assets/img/photos/all/6.jpg')} 1000w`" />
           />
        </div>

        <div class="lightbox animate" id="img8">
          <LightboxClose />
          <LightboxPrev previous="#img6" />
          <LightboxNext next="#img10" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/8.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/8.jpg')} 500w, ${require('@/assets/img/photos/all/8.jpg')} 1000w`" />
            />
        </div>

        <div class="lightbox animate" id="img10">
          <LightboxClose />
          <LightboxPrev previous="#img8" />
          <LightboxNext next="#img12" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/10.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/10.jpg')} 500w, ${require('@/assets/img/photos/all/10.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img12">
          <LightboxClose />
          <LightboxPrev previous="#img10" />
          <LightboxNext next="#img14" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/12.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/12.jpg')} 500w, ${require('@/assets/img/photos/all/12.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img14">
          <LightboxClose />
          <LightboxPrev previous="#img12" />
          <LightboxNext next="#img16" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/14.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/14.jpg')} 500w, ${require('@/assets/img/photos/all/14.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img16">
          <LightboxClose />
          <LightboxPrev previous="#img14" />
          <LightboxNext next="#img18" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/16.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/16.jpg')} 500w, ${require('@/assets/img/photos/all/16.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img18">
          <LightboxClose />
          <LightboxPrev previous="#img16" />
          <LightboxNext next="#img20" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/18.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/18.jpg')} 500w, ${require('@/assets/img/photos/all/18.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img20">
          <LightboxClose />
          <LightboxPrev previous="#img18" />
          <LightboxNext next="#img22" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/20.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/20.jpg')} 500w, ${require('@/assets/img/photos/all/20.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img22">
          <LightboxClose />
          <LightboxPrev previous="#img20" />
          <LightboxNext next="#img24" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/22.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/22.jpg')} 500w, ${require('@/assets/img/photos/all/22.jpg')} 1000w`" />
             />
        </div>

        <div class="lightbox animate" id="img24">
          <LightboxClose />
          <LightboxPrev previous="#img22" />
          <LightboxNext next="#img2" />
          <img
            class="animate"
            v-lazy="require('@/assets/img/photos/all/24.jpg')"
            :data-srcset="`${require('@/assets/img/photos/all/half-size/24.jpg')} 500w, ${require('@/assets/img/photos/all/24.jpg')} 1000w`" />
             />
        </div>

        <div class="gallery-item">
          <a class="thumbnail" href="#img2"><img src="@/assets/img/photos/all/thumbs/thumb_2.jpg" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img4"><img src="@/assets/img/photos/all/thumbs/thumb_4.jpg" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img6"><img src="@/assets/img/photos/all/thumbs/thumb_6.jpg" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img8"><img src="@/assets/img/photos/all/thumbs/thumb_8.jpg" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img10"><img src="@/assets/img/photos/all/thumbs/thumb_10.jpg" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img12"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_12.jpg')" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img14"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_14.jpg')" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img16"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_16.jpg')" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img18"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_18.jpg')" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img20"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_20.jpg')" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img22"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_22.jpg')" /></a>
        </div>
        <div class="gallery-item">
          <a class="thumbnail" href="#img24"><img v-lazy="require('@/assets/img/photos/all/thumbs/thumb_24.jpg')" /></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LightboxPrev from '@/components/LightboxPrev'
import LightboxNext from '@/components/LightboxNext'
import LightboxClose from '@/components/LightboxClose'

export default {
  name: 'Photos',
  components: {
    LightboxPrev,
    LightboxNext,
    LightboxClose
  }
}

</script>

<style>
/* Removes browser highlight outlines for all links */

a {
  outline: none;
}

  /* Styles the lightbox, removes it from sight and adds the fade-in transition */

.lightbox {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);
  visibility: hidden;
  opacity: 0;
}

.arrow {
  display: flex;
  position: absolute;
  top: 30%;
  width: 10%;
  height: 40%;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 99;
  align-items: center;
  justify-content: center;
}

.lightboxPrev {
  left: 0px;
}

.lightboxNext {
  right: 0px;
}

.lightboxClose {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 1%;
}

.arrow i, .close i {
  color: #fff;
  text-shadow: 1px 1px 15px rgba(0, 0, 0, .4);
  font-size: 3rem;
}

.animate {
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -ms-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

  /* Styles the lightbox content, centering it vertically and horizontally, adds the zoom-in transition and makes it responsive using a combination of margin and absolute positioning */

.lightbox img, .lightbox iframe {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 40%;
  max-height: 40%;
  border: 2px solid white;
  box-sizing: border-box;
}

  /* Uses the :target pseudo-class to perform the animations upon clicking the .lightbox anchor */

.lightbox:target {
  visibility: visible;
  opacity: 1;
  z-index: 100;
}

.lightbox:target img, .lightbox:target iframe {
  max-width: 95%;
  max-height: 95%;
}
a.thumbnail {
  padding: 1rem;
  display: block;
}
a.thumbnail img {
  max-width: 100%;
  display: block;
}

</style>
